import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getSession } from '@techstyle/redux-core';

import { trackProductImpression } from '../../actions/products';

import ProductImpression from './ProductImpression';

export function mapStateToProps(state, ownProps) {
  return {
    sessionId: getSession(state).sessionId,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      trackProductImpression,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductImpression);
